import { $themeBreakpoints } from '@themeConfig'
import VueCookies from 'vue-cookies'
import jwt from 'jsonwebtoken'

const rawToken = $cookies.get('jwt')
const decoded = rawToken ? jwt.decode(rawToken) : null

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    storeReady: false,
    userData: 
      decoded ? {
        "id": decoded?.serial,
        "fullName": decoded?.name,
        "username": decoded?.sub,
        "expires": decoded?.exp,
        "avatar":null,
        "email": decoded?.sub,
        "scope": decoded?.scope,
        "role": decoded?.name === "Vasilis Pallidis Insurance Brokers" ? "admin" :"client",
        "ability": [{"action":"manage","subject":"all"}],
        "extras": {"eCommerceCartItemsCount":0}
      } : null
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    USER_DATA(state, val) {
      state.userData = val
    },
    SET_STORE_READY(state, val) {
      state.storeReady = val
    }
  },
  actions: {},
}
